export const addresses = {
  pnouns: "0x0d6e43d4d7944408d9a5A10BC57B4348d61cD764",
};
